// // import produce from 'immer';
// import createState from '../Common/react-copy-write/src';
import createState from 'react-copy-write';

const {mutate, Consumer, Provider} = createState({
  empresa: {
    id: null,
    data: null,
  },
  empregados: null
})

export { mutate, Consumer, Provider }
